var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g(_vm._b({class:['svg-icon', _vm.$attrs.class, _vm.spin && 'svg-icon-spin'],style:(_vm.getStyle),attrs:{"aria-hidden":"true"}},'svg',_vm.$attrs,false),_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.symbolId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }